const { getAxiosInstance } = require('../connection');

module.exports = {
    login: function (email, password) {
        return getAxiosInstance({
            url: '/login',
            method: 'POST',
            json: true,
            data: {
                email,
                password,
            },
        }).then((response) => response.data);
    },
    logout: function () {
        return getAxiosInstance({
            url: '/logout',
            method: 'POST',
            json: true,
            data: {},
        }).then((response) => response.data);
    },
    restoreSession: function (userId, authToken) {
        return getAxiosInstance({
            url: '/users/' + encodeURIComponent(userId),
            method: 'GET',
            json: true,
            headers: {
                'X-Inscene-Requester-Id': authToken,
            },
        }).then((response) => response.data);
    },
    register: function (email, password, firstName, lastName) {
        return getAxiosInstance({
            url: '/users?errorresponse=json',
            method: 'POST',
            json: true,
            data: {
                email,
                password,
                first_name: firstName,
                last_name: lastName,
            },
        }).then((response) => response.data);
    },
    linkedinLogin: function (code, state, redirect_uri) {
        return getAxiosInstance({
            url: '/linkedin',
            method: 'POST',
            json: true,
            data: {
                oauth2_code: code,
                redirect_uri: redirect_uri,
                state: state,
                version: '2',
            },
        }).then((response) => response.data);
    },
    socialLogin: function (provider, oauth2_code, token, { firstName, lastName } = {}) {
        const data = {
            provider,
            oauth2_code,
            token,
        };

        if (firstName) data.first_name = firstName;
        if (lastName) data.last_name = lastName;

        return getAxiosInstance({
            url: '/social-signin',
            method: 'POST',
            json: true,
            data,
        }).then((response) => response.data);
    },
    SocialLoginProviders: {
        APPLE: 'apple-id',
        LINKEDIN: 'linkedin',
    },
    recoverPassword: function (email, flow) {
        return getAxiosInstance({
            url: '/recover/' + encodeURIComponent(email),
            method: 'POST',
            json: true,
            data: { flow: flow || 'online-app' },
        }).then((response) => response.data);
    },
    requestOAuthCode: function (client, redirect_uri, state) {
        return getAxiosInstance({
            url: '/request_code',
            method: 'POST',
            json: true,
            data: {
                client_id: client,
                redirect_uri,
                state,
            },
        }).then((response) => response.data);
    },
    getUpdates: function () {
        return getAxiosInstance({
            url: '/updates',
            method: 'GET',
        }).then((response) => response.data);
    },
};
